import store from '@/store'
import { computed } from 'vue'

const currentUserId = computed(() => store.state.user.id)
const currentUserProfile = computed(() => store.state.user.profile)
const isLoggedIn = computed(() => store.state.user.userLoggedIn)
const isAnonymous = computed(() => !!store.state.user.profile?.anonymous)
const region = computed(() => store.state.user.profile?.transcodingregion ?? 'us-east')

const useCurrentUserProfile = () => {
  return {
    currentUserId,
    currentUserProfile,
    isAnonymous,
    isLoggedIn,
    region
  }
}

export default useCurrentUserProfile
